import { render, staticRenderFns } from "./RecipeSortSelect.vue?vue&type=template&id=cb3a21fa&scoped=true"
import script from "./RecipeSortSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeSortSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeSortSelect.vue?vue&type=style&index=0&id=cb3a21fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a21fa",
  null
  
)

export default component.exports